import { AvatarSizes, DefaultTeamLogo } from '@capsicum/common';
import { Avatar, Button, ButtonSection, ResponsiveContainer } from '@capsicum/common-web';
import { ChilizChainCircleIcon } from '@capsicum/common-web/icons';
import { type NCWSendAssetType } from '@capsicum/socios-core';
import styled from 'styled-components';

export type NCWAssetSelectionButtonSectionProps = {
	isLoading: boolean;
	onSubmit: () => void;
	selectedAsset?: NCWSendAssetType;
	submitButtonText: string;
};

export const NCWAssetSelectionButtonSection = ({
	isLoading,
	onSubmit,
	selectedAsset,
	submitButtonText
}: NCWAssetSelectionButtonSectionProps) => (
	<ButtonSection $alwaysFixedPosition>
		<S.Content $variant="subpage">
			<div>
				{selectedAsset &&
					(selectedAsset.shortCode === 'CHZ' ? (
						<ChilizChainCircleIcon height={AvatarSizes.S} width={AvatarSizes.S} />
					) : (
						<Avatar size="S" src={selectedAsset.imageUri || DefaultTeamLogo} />
					))}
			</div>

			<Button
				color="brand"
				disabled={!selectedAsset}
				isLoading={isLoading}
				testID="ncw-send-assetSelector-buttonSection-button"
				text={submitButtonText}
				variant="default"
				onClick={onSubmit}
			/>
		</S.Content>
	</ButtonSection>
);

namespace S {
	export const Content = styled(ResponsiveContainer)`
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: ${AvatarSizes.S}px;
		padding: 0 ${({ theme }) => theme.spacings.small};
		box-sizing: border-box;
	`;
}
